import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "revenuerulesets",
    defaultRoutePath: "/administrations/revenueruleset",
    menuItemScope: "administration",
    menuItemName: "revenuerulesets",

    routes: [
        {
            path: "/administrations/revenueruleset",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        
        {
            path: "create",
            Component: Wizards.Create,
        },
    ],

}

export default Module;